import { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { Trophy } from "lucide-react";
import { api } from "@/lib/api";
import { AgencyPodium } from "@/components/AgencyPodium";

export default function TopAgencies() {
  const [month, setMonth] = useState("");
  const { data: months } = useQuery({ queryKey: ["ranking-months"], queryFn: async () => (await api.get("/rankings/months")).data });

  useEffect(() => {
    if (months?.length && !month) setMonth(months[0].month_key);
  }, [months, month]);

  const { data: ranking, isLoading } = useQuery({
    queryKey: ["ranking", month],
    queryFn: async () => (await api.get("/rankings/published", { params: month ? { month } : {} })).data,
  });

  return (
    <div className="mx-auto max-w-5xl px-4 py-12 sm:px-6 lg:px-12">
      <div className="text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold">Hall of Fame</p>
        <h1 className="mt-2 font-display text-4xl font-extrabold text-white sm:text-5xl">Top 3 Agency Ranking</h1>
        <p className="mt-3 text-slate-400">Celebrating the top performing agencies of the month.</p>
      </div>

      {months?.length > 0 && (
        <div className="mt-8 flex flex-wrap justify-center gap-2" data-testid="agency-month-selector">
          {months.map((m) => (
            <button
              key={m.month_key}
              onClick={() => setMonth(m.month_key)}
              data-testid={`agency-month-${m.month_key}`}
              className={`rounded-full px-5 py-2 text-sm font-semibold transition-colors ${
                month === m.month_key ? "gold-gradient text-obsidian" : "border border-gold/25 text-slate-300 hover:border-gold/60"
              }`}
            >
              {m.month_label}
            </button>
          ))}
        </div>
      )}

      <div className="mt-12">
        {isLoading && <p className="text-center text-slate-500">Loading...</p>}
        {!isLoading && (!ranking || !ranking.agencies?.length) && (
          <div className="flex flex-col items-center gap-3 py-16 text-center" data-testid="ranking-empty">
            <Trophy className="h-12 w-12 text-gold/40" />
            <p className="text-slate-500">No ranking published yet.</p>
          </div>
        )}
        {ranking?.agencies?.length > 0 && (
          <>
            <h2 className="mb-8 text-center font-display text-2xl gold-text">{ranking.month_label}</h2>
            <AgencyPodium agencies={ranking.agencies} />
          </>
        )}
      </div>
    </div>
  );
}
